import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { About } from './components/About';
import { Expertise } from './components/Expertise';
import { Skills } from './components/Skills';
import { Experience } from './components/Experience';
import { Impact } from './components/Impact';
import { LeadershipStyle } from './components/LeadershipStyle';
import { Education } from './components/Education';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-navy selection:bg-gold selection:text-navy" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <About data-id="element-4" />
        <Expertise data-id="element-5" />
        <Skills data-id="element-6" />
        <Experience data-id="element-7" />
        <Impact data-id="element-8" />
        <LeadershipStyle data-id="element-9" />
        <Education data-id="element-10" />
        <Contact data-id="element-11" />
      </main>
      <Footer data-id="element-12" />
    </div>;
}